/* import __COLOCATED_TEMPLATE__ from './basic-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();